export default __webpack_public_path__ + "static/media/arb.993e03ac.png";